import {
  buttons_MATERIAL_TYPE,
  FABRIC_MATERIAL_TYPE,
  VENDOR_MATERIAL_TYPE,
}

  from '../../components/constants/materialTypes'

const FABRIC_MATERIAL_VALUE = null;
const buttons_MATERIAL_VALUE = null;
const VENDOR_MATERIAL_VALUE = 'remark_birka';


export default {
  body: {
    value: 'bodyShirt',
    parts: {
      Parent: {
        material: FABRIC_MATERIAL_TYPE,
        materialValue: FABRIC_MATERIAL_VALUE,
        position: 0
      },
      Internal: {
        material: FABRIC_MATERIAL_TYPE,
        materialValue: FABRIC_MATERIAL_VALUE,
        position: 1
      },
      Logo: {
        material: VENDOR_MATERIAL_TYPE,
        materialValue: VENDOR_MATERIAL_VALUE,
        position: 2,
      },
      Button: {
        material: buttons_MATERIAL_TYPE,
        materialValue: buttons_MATERIAL_VALUE,
        position: 3
      },
    }
  },
  collar: {
    value: 'collarColorado',
    parts: {
      InternalStand: {
        material: FABRIC_MATERIAL_TYPE,
        materialValue: FABRIC_MATERIAL_VALUE,
        position: 3
      },
      ExternalStand: {
        material: FABRIC_MATERIAL_TYPE,
        materialValue: FABRIC_MATERIAL_VALUE,
        position: 4
      },
      Button: {
        material: buttons_MATERIAL_TYPE,
        materialValue: buttons_MATERIAL_VALUE,
        position: 5
      },
      Parent: {
        material: FABRIC_MATERIAL_TYPE,
        materialValue: FABRIC_MATERIAL_VALUE,
        position: 6
      }
    }
  },
  cuff: {
    value: 'cuffStraight',
    parts: {
      Internal: {
        material: FABRIC_MATERIAL_TYPE,
        materialValue: FABRIC_MATERIAL_VALUE,
        position: 7
      },
      External: {
        material: FABRIC_MATERIAL_TYPE,
        materialValue: FABRIC_MATERIAL_VALUE,
        position: 8
      },
      Button: {
        material: buttons_MATERIAL_TYPE,
        materialValue: buttons_MATERIAL_VALUE,
        position: 9
      }
    }
  },
  pocket: {
    value: 'pocketNone',
    parts: {
      Parent: {
        material: FABRIC_MATERIAL_TYPE,
        materialValue: FABRIC_MATERIAL_VALUE,
        position: 10
      }
    }
  },
}
